import React from 'react';
import CategoryNavRibbon from '../category-nav-ribbon/category-nav-ribbon';
import NavBar from './nav-bar/nav-bar';
import { MhhNavBar } from './nav-bar/mhh-nav-bar';
import { MhcDesktopNavBar } from './nav-bar/mhc-desktop-nav-bar';
import SimpleHeader from './simple-header/simple-header';
import SimpleHeaderOnSyi from './simple-header/simple-header-syi';

export type HeaderLayout = 'legacy' | 'mhh' | 'mhc' | 'mhcDesktop';

type HeaderLayoutProps = {
    showSimpleHeaderOnly?: boolean;
    showOnMobile: boolean;
    showOnSyiPostFlow: boolean;
    isMhhExperiment: boolean;
};

export const resolveHeaderLayout = ({
    useMhhLayout,
    useMhcLayout,
    useMhcDesktopLayout,
}: {
    useMhhLayout: boolean;
    useMhcLayout: boolean;
    useMhcDesktopLayout: boolean;
}): HeaderLayout => {
    if (useMhhLayout) return 'mhh';
    if (useMhcLayout) return 'mhc';
    if (useMhcDesktopLayout) return 'mhcDesktop';
    return 'legacy';
};

const LegacyHeaderLayout = ({
    showSimpleHeaderOnly,
    showOnMobile,
    showOnSyiPostFlow,
    isMhhExperiment,
}: HeaderLayoutProps) => {
    let content: React.ReactNode;

    if (showSimpleHeaderOnly) {
        content = <SimpleHeader />;
    } else if (showOnMobile && showOnSyiPostFlow) {
        content = <SimpleHeaderOnSyi />;
    } else {
        content = (
            <>
                <NavBar isMhhExperiment={isMhhExperiment && showOnMobile} />
                <CategoryNavRibbon />
            </>
        );
    }

    return <header className="header">{content}</header>;
};

const MhhHeaderLayout = () => (
    <>
        <MhhNavBar />
        <CategoryNavRibbon />
    </>
);

const MhcHeaderLayout = () => (
    <>
        <NavBar isMhcSticky />
        <CategoryNavRibbon />
    </>
);

const MhcDesktopHeaderLayout = () => (
    <header className="header">
        <MhcDesktopNavBar />
        <CategoryNavRibbon isMhcDesktop />
    </header>
);

export const renderHeaderLayout = (layout: HeaderLayout, props: HeaderLayoutProps) => {
    if (layout === 'mhh') return <MhhHeaderLayout />;
    if (layout === 'mhc') return <MhcHeaderLayout />;
    if (layout === 'mhcDesktop') return <MhcDesktopHeaderLayout />;
    return <LegacyHeaderLayout {...props} />;
};
